var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spr-radio-list"},_vm._l((_vm.options),function(item,index){return _c('spr-radio',{key:index,attrs:{"title":item.text,"value":item.value,"model-value":_vm.value,"name":_vm.name},on:{"input":_vm.onRadioClicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }